import { Component, Inject } from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { AccountViewModel } from "@tylertech/tyler-api-types";

export interface AccountBudgetRecapDialogData
{
    readonly accounts: Array<AccountViewModel>;
    readonly summaryDate: Date | string;
}

@Component({
    selector: "gl-account-budget-recap-dialog",
    templateUrl: "./accountBudgetRecapDialog.tmpl.html",
    standalone: false
})
export class AccountBudgetRecapDialogComponent
{
    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: AccountBudgetRecapDialogData)
    { }

    get accounts(): Array<AccountViewModel> { return this.data.accounts; }
    get summaryDate(): Date | string { return this.data.summaryDate; }
}
